import React from 'react'
import SALink from 'components/SALink'
import { NoResults } from 'styles/algolia/artwork'
import { ArtworksList as CollectionsList } from '../styles'
import Polaroid from './polaroids/Polaroid'
import CollectionsListConnector, {
  ConnectorProps as ListProps,
} from '../../connectors/CollectionsList'
import { capitalizeString } from 'lib/helpers'

export default CollectionsListConnector((props: ListProps) => {
  const { collectionsList, isUsersCollectionPage, artistName } = props
  const capitalizedArtistName = capitalizeString(artistName)

  if (isUsersCollectionPage && !collectionsList.length) {
    return (
      <CollectionsList>
        <Polaroid artwork='upload' data-type='uploadArt' key='collection-owner-upload-00' />
      </CollectionsList>
    )
  }

  if (!collectionsList.length) {
    return (
      <NoResults>
        {capitalizedArtistName} has no collections yet. Browse{' '}
        <SALink href='/collections/browse'>now</SALink> for other collections.
      </NoResults>
    )
  }

  return (
    <CollectionsList>
      <>
        {isUsersCollectionPage && (
          <Polaroid artwork='upload' data-type='uploadArt' key='collection-owner-upload-00' />
        )}

        {collectionsList.map((collection, index) => {
          const { collectionTitle, collectionCount, collectionUrl, mainImage, thumbs } = collection
          return (
            <Polaroid
              key={`collection-${index + 1}`}
              collectionTitle={collectionTitle}
              collectionCount={collectionCount}
              collectionUrl={collectionUrl}
              imageUrl={mainImage}
              aspectRatio='1'
              thumbs={thumbs}
              index={index + 1}
            />
          )
        })}
      </>
    </CollectionsList>
  )
})
